export default "__VITE_ASSET__DGgeEG0U__"